import { useLocation } from '@hulu/react-router-dom';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

/**
 * Hotfix page to show SourceAdIds
 */
const SourceAdIds: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<Record<string, unknown> | null>(null);
  const location = useLocation();

  async function getSourceAdIdData(ids: string): Promise<void> {
    const result = await axios.get(`/api/source-ad-data?sourceAdIdList=${ids}`);

    if (result.data) setData(result.data);
    setIsLoading(false);
  }

  useEffect(() => {
    const searchParams = location.search ? new URLSearchParams(location.search) : null;

    if (searchParams) {
      const ids = searchParams.get('ids');
      if (ids) getSourceAdIdData(ids);
    }
  }, [location]);

  return (
    <div style={{ width: '100%', maxHeight: 'fit-content', overflow: 'auto' }}>
      {isLoading ? (
        <div>loading...</div>
      ) : data ? (
        <pre>{JSON.stringify(data, null, '  ')}</pre>
      ) : (
        <div>unable to retrieve data</div>
      )}
    </div>
  );
};

export default SourceAdIds;
